/**
 * Generated from ch3_p03.fla
 */
export function ch3_p03(this: Ich3_p03) {
	const bg = this.bg;
	if (!bg[0] && bg.elementFactory) {
		bg[0] = bg.elementFactory(0,undefined);
	}
	if (bg[0]) {
		ch3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroom.call(bg[0] as Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroom);
		bg[0].x = 832;
		bg[0].y = 384;
		bg[0].width = 1664.00;
		bg[0].height = 768.00;
		bg[0].alpha = 1;
		if (bg[0].onLayout) bg[0].onLayout();
	}
	if (!bg[1] && bg.elementFactory) {
		bg[1] = bg.elementFactory(1,undefined);
	}
	if (bg[1]) {
		ch3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroomcopy.call(bg[1] as Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroomcopy);
		bg[1].x = 2044.5;
		bg[1].y = 384;
		bg[1].width = 761.00;
		bg[1].height = 767.95;
		bg[1].alpha = 1;
		if (bg[1].onLayout) bg[1].onLayout();
	}
	const bedMessy = this.bedMessy;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedmessy.call(this.bedMessy);
	bedMessy.x = 621;
	bedMessy.y = 487.75;
	bedMessy.width = 748.00;
	bedMessy.height = 413.50;
	bedMessy.alpha = 1.00;
	if (bedMessy.onLayout) bedMessy.onLayout();
	const bedClean = this.bedClean;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedclean.call(this.bedClean);
	bedClean.x = 621;
	bedClean.y = 487.75;
	bedClean.width = 748.00;
	bedClean.height = 413.50;
	bedClean.alpha = 1.00;
	if (bedClean.onLayout) bedClean.onLayout();
	const nightstandOpen = this.nightstandOpen;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandopen.call(this.nightstandOpen);
	nightstandOpen.x = 303;
	nightstandOpen.y = 538.5;
	nightstandOpen.width = 274.00;
	nightstandOpen.height = 377.00;
	nightstandOpen.alpha = 1.00;
	if (nightstandOpen.onLayout) nightstandOpen.onLayout();
	const nightstandClosed = this.nightstandClosed;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandclosed.call(this.nightstandClosed);
	nightstandClosed.x = 280.25;
	nightstandClosed.y = 538.5;
	nightstandClosed.width = 228.50;
	nightstandClosed.height = 377.00;
	nightstandClosed.alpha = 1.00;
	if (nightstandClosed.onLayout) nightstandClosed.onLayout();
	const clothingDown = this.clothingDown;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingdown.call(this.clothingDown);
	clothingDown.x = 1286.5;
	clothingDown.y = 304;
	clothingDown.width = 153.00;
	clothingDown.height = 197.00;
	clothingDown.alpha = 1.00;
	if (clothingDown.onLayout) clothingDown.onLayout();
	const clothingUp = this.clothingUp;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingup.call(this.clothingUp);
	clothingUp.x = 1290.75;
	clothingUp.y = 333.5;
	clothingUp.width = 91.50;
	clothingUp.height = 229.00;
	clothingUp.alpha = 1.00;
	if (clothingUp.onLayout) clothingUp.onLayout();
	const floorItemsDown = this.floorItemsDown;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsdown.call(this.floorItemsDown);
	floorItemsDown.x = 1107.45;
	floorItemsDown.y = 679.25;
	floorItemsDown.width = 173.00;
	floorItemsDown.height = 112.50;
	floorItemsDown.alpha = 1.00;
	if (floorItemsDown.onLayout) floorItemsDown.onLayout();
	const floorItemsUp = this.floorItemsUp;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsup.call(this.floorItemsUp);
	floorItemsUp.x = 1115.95;
	floorItemsUp.y = 654;
	floorItemsUp.width = 150.00;
	floorItemsUp.height = 111.00;
	floorItemsUp.alpha = 1.00;
	if (floorItemsUp.onLayout) floorItemsUp.onLayout();
	const basket = this.basket;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basket.call(this.basket);
	basket.x = 564;
	basket.y = 700.75;
	basket.width = 283.00;
	basket.height = 134.50;
	basket.alpha = 1.00;
	if (basket.onLayout) basket.onLayout();
	const basketLidOff = this.basketLidOff;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidoff.call(this.basketLidOff);
	basketLidOff.x = 726.75;
	basketLidOff.y = 682.75;
	basketLidOff.width = 91.50;
	basketLidOff.height = 170.50;
	basketLidOff.alpha = 1.00;
	if (basketLidOff.onLayout) basketLidOff.onLayout();
	const basketLidOn = this.basketLidOn;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidon.call(this.basketLidOn);
	basketLidOn.x = 564.5;
	basketLidOn.y = 651.25;
	basketLidOn.width = 296.00;
	basketLidOn.height = 91.50;
	basketLidOn.alpha = 1.00;
	if (basketLidOn.onLayout) basketLidOn.onLayout();
	const guitar = this.guitar;
	ch3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305Guitar.call(this.guitar);
	guitar.x = 1648.25;
	guitar.y = 384.7;
	guitar.width = 112.50;
	guitar.height = 248.44;
	guitar.alpha = 1.00;
	if (guitar.onLayout) guitar.onLayout();
	const frameRight = this.frameRight;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameLframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 767.50;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRFrame.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 767.50;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRlineart.call(this.linesLeft);
	linesLeft.x = 57.75;
	linesLeft.y = 384;
	linesLeft.width = 115.50;
	linesLeft.height = 768.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroomcopy(this: Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroomcopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("bedroomcopy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroom(this: Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroom) {
	if (this.setLayoutTexture) this.setLayoutTexture("bedroom", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedmessy(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedmessy) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p03_bedmessy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedclean(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedclean) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p03_bedclean", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandopen(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandopen) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p03_nightstandopen", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandclosed(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandclosed) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p03_nightstandclosed", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingdown(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingdown) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_clothingdown", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingup(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingup) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_clothingup", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsdown(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsdown) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_flooritemsdown", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsup(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsup) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_flooritemsup", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basket(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basket) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_basket", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidoff(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidoff) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_basketlidoff", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidon(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidon) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_basketlidon", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305Guitar(this: Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305Guitar) {
	if (this.setLayoutTexture) this.setLayoutTexture("Guitar", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameLframe(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRFrame(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRFrame) {
	if (this.setLayoutTexture) this.setLayoutTexture("RFrame", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRlineart(this: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRlineart) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rlineart", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich3_p03Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich3_p03Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich3_p03Sprite extends Ich3_p03Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich3_p03Text extends Ich3_p03Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich3_p03Polygon extends Array<number> {
}
interface Ich3_p03 {
	readonly bg: Ich3_p03Array<Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroom|Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroomcopy>;
	readonly bedMessy: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedmessy;
	readonly bedClean: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedclean;
	readonly nightstandOpen: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandopen;
	readonly nightstandClosed: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandclosed;
	readonly clothingDown: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingdown;
	readonly clothingUp: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingup;
	readonly floorItemsDown: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsdown;
	readonly floorItemsUp: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsup;
	readonly basket: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basket;
	readonly basketLidOff: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidoff;
	readonly basketLidOn: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidon;
	readonly guitar: Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305Guitar;
	readonly frameRight: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameLframe;
	readonly frameLeft: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRFrame;
	readonly linesLeft: Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRlineart;
}
interface Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroomcopy extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305bedroom extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedmessy extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_bedclean extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandopen extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_nightstandclosed extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingdown extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305clothingchp3_p01_clothingup extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsdown extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305floorItemschp3_p01_flooritemsup extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basket extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidoff extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p01_basketlidon extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405_longerpsdAssetP0305Guitar extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameLframe extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRFrame extends Ich3_p03Sprite {
}
interface Ich3_p03_hh_ch3_72dpi_p030405psdAssetP0305chp3_p03_wcfameRlineart extends Ich3_p03Sprite {
}
